import { FormEvent, useEffect, useState } from "react"
import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Button } from "@/components/ui/button"
import { PlayerStatsDashboard } from "@/components/profile/PlayerStatsDashboard"

interface PlayerStatsLookupProps {
  initialPlayerCode?: string
}

export function PlayerStatsLookup({ initialPlayerCode }: PlayerStatsLookupProps) {
  const [playerCode, setPlayerCode] = useState("")
  const [searchedPlayerCode, setSearchedPlayerCode] = useState("")

  useEffect(() => {
    const normalizedCode = initialPlayerCode?.trim()
    if (!normalizedCode) {
      setPlayerCode("")
      setSearchedPlayerCode("")
      return
    }

    setPlayerCode(normalizedCode)
    setSearchedPlayerCode(normalizedCode)
  }, [initialPlayerCode])

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const normalizedCode = playerCode.trim()
    if (!normalizedCode) return
    setSearchedPlayerCode(normalizedCode)
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="pt-6">
          <form onSubmit={onSubmit} className="flex flex-col gap-4 md:flex-row md:items-end">
            <div className="flex-1 space-y-2">
              <Label htmlFor="playerCode">Codigo del jugador</Label>
              <Input
                id="playerCode"
                value={playerCode}
                onChange={(event) => setPlayerCode(event.target.value)}
                placeholder="Ejemplo: CL12345"
                autoComplete="off"
              />
            </div>

            <Button type="submit" disabled={!playerCode.trim()}>
              Buscar estadisticas
            </Button>
          </form>
        </CardContent>
      </Card>

      {searchedPlayerCode ? (
        <PlayerStatsDashboard playerCode={searchedPlayerCode} showPlayerIdentity />
      ) : (
        <Card>
          <CardContent className="py-8 text-center text-muted-foreground">
            Ingresa un codigo para ver las estadisticas de un jugador.
          </CardContent>
        </Card>
      )}
    </div>
  )
}
